import { Dispatch, SetStateAction } from 'react'
import { SPORT_POLL_STORE, SportPollStore } from 'store'
import { SportPoll } from '../SportForm/types'

export enum SportPollTableHeaders {
    QUESTION = 'Question',
    OPTIONS = 'Options',
    ANSWER = 'Answers',
    START_TIME= 'Start Time',
    END_TIME= 'End Time',
    RESULT_TIME= 'Result Time',
    ACTION = 'Action'
}

export interface SportPollTableProps{
    [SPORT_POLL_STORE]?: SportPollStore;
    onEditSportForm : Dispatch<SetStateAction<SportPoll>>
}

// Breakpoints
export const BREAKPOINTS = {
  MEDIUM: 1024
}

// Widths for screens > 1024 (using percentage for full fit)
export enum SportPollTableWidthLargePercent {
    START_TIME = 7, // 7%
    END_TIME = 7, // 7%
    RESULT_TIME = 7, // 7%
    QUESTION = 25, // 25%
    OPTIONS = 29, // 29%
    ANSWER = 15, // 15%
    ACTION = 10 // 10%
}

// Widths for screens <= 1024
export enum SportPollTableWidth {
    START_TIME = 110,
    END_TIME = 110,
    RESULT_TIME = 110,
    QUESTION = 320,
    OPTIONS = 340,
    ANSWER = 220,
    ACTION = 100
}

// Type for table column width configuration
export interface TableColumnWidth {
  START_TIME: number
  END_TIME: number
  RESULT_TIME: number
  QUESTION: number
  OPTIONS: number
  ANSWER: number
  ACTION: number
}

export interface TableWidthConfig {
  widths: TableColumnWidth
  usePercentage: boolean
}

// Helper function to get appropriate widths based on screen size
export const getSportPollTableWidth = (): TableWidthConfig => {
  const width = window.innerWidth

  const shouldUsePercentage = width > BREAKPOINTS.MEDIUM
  return {
    widths: shouldUsePercentage ? SportPollTableWidthLargePercent : SportPollTableWidth,
    usePercentage: shouldUsePercentage
  }
}
